import type from '@/helpers/rave/constants/types'

export default {
  [type.GENERATOR]: 'Satisfaction',
  [type.MAN_GENERATOR]: 'Satisfaction',
  [type.MANIFESTOR]: 'Peace',
  [type.PROJECTOR]: 'Success',
  [type.REFLECTOR]: 'Surprise'
}
